import { render, staticRenderFns } from "./appletEdition.vue?vue&type=template&id=25adf3f7&"
import script from "./appletEdition.vue?vue&type=script&lang=js&"
export * from "./appletEdition.vue?vue&type=script&lang=js&"
import style0 from "./appletEdition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports